export const ChargeWayEnum = {
  'L1': 'cpd', 'L2': 'cpmT', 'L3': 'cpmL', 'L4': 'pkg', 'L5': 'rtb'
}